import { render, staticRenderFns } from "./grxx.vue?vue&type=template&id=104e9030&scoped=true&"
import script from "./grxx.vue?vue&type=script&lang=js&"
export * from "./grxx.vue?vue&type=script&lang=js&"
import style0 from "./grxx.vue?vue&type=style&index=0&id=104e9030&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e9030",
  null
  
)

export default component.exports